var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Terms Of Service")]),_c('hr'),_c('terms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }